import { render, staticRenderFns } from "./TableForm.vue?vue&type=template&id=6ae26c91"
import script from "./TableForm.vue?vue&type=script&lang=ts"
export * from "./TableForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports